import { useSelector } from "react-redux";

const StockPriceUpdate = () => {
  const OrgId = useSelector((state) => state.auth.org_id);
    return (
      <div className="">
          <iframe src={`https://iiplwork.retool.com/embedded/public/2cdb24bb-963f-4885-b7e6-f7c81901509f`}
          className="iframe-style"></iframe>
      </div>
  
    )
  };
  
  export default StockPriceUpdate;
  